import { render, staticRenderFns } from "./BaseOrgan.vue?vue&type=template&id=5c919616"
import script from "./BaseOrgan.vue?vue&type=script&lang=ts"
export * from "./BaseOrgan.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports